import Vue from 'vue'
import moment from 'moment'

const initialState = JSON.parse(localStorage.getItem('@datadrive:initialState'));
const domainData = JSON.parse(localStorage.getItem('@datadrive:domain'));
const nullDateValue = '0001-01-01T00:00:00';
let lang = 'pt';
if (initialState) {
    lang = initialState.languageCode;
} else {
    if (domainData) {
        lang = domainData.languageCode;
    }
}

/**
 * @param format can be sent as a parameter, in which case it is applied, else, if no format is specified, it defaults to 'DD/MM/YYYY hh:mm'
 * @returns the formated date
 */
Vue.filter('formatDate', function (value, format = 'DD/MM/YYYY HH:mm') {
    if (value && value != nullDateValue) {
        return moment.utc(String(value)).local().format(format);
    }
});

Vue.filter('formatDateTimezone', function (value, format = 'DD/MM/YYYY HH:mm') {
    if (value && value != nullDateValue) {
        return moment(String(value)).format(format);
    }
});

Vue.filter('formatDate24h', function (value, format = 'DD/MM/YYYY HH:mm') {
    if (value && value != nullDateValue) {
        return moment.utc(String(value)).local().format(format);
    }
});

Vue.filter('formatDate24hFromTimestamp', function (value, format = 'DD/MM/YYYY HH:mm') {
    if (value && value != nullDateValue) {
        return moment.utc(new Date(+value)).local().format(format);
    }
});

Vue.filter('formatDate24hMs', function (value, format = 'DD/MM/YYYY HH:mm:ss') {
    if (value && value != nullDateValue) {
        return moment.utc(String(value)).local().locale(lang).format(format);
    }
});

/**
 * @returns value in formate hh:mm
 */
Vue.filter('formatTime', function (value) {
    if (value) {
        const parts = value.split(":");
        return + parts[0] + ":" + parts[1];
    } else {
        return "unknown"
    }
});

Vue.filter('formatOnlyDate', function (value, format = 'DD/MM/YYYY') {
    if (value == '-' || value == 'invalid date') {
        return '-';
    }
    if (value) {
        return moment.utc((String(value))).local(lang).locale(lang).format(format);
    }
});

// July 9, 2021
Vue.filter('formatLLDate', function (value) {
    moment.utc((String(value))).local().locale(lang).format('LL')
});

/**
 * @param format can be sent as a parameter, in which case it is applied, else, if no format is specified, it defaults to 'DD/MM/YYYY hh:mm'
 * @returns the formated date
 */
Vue.filter('formatTimeOld', function (value, format = 'HH:mm:ss') {
    if (value) {
        return moment.utc((String(value))).local().format(format);
    }
});

Vue.filter('formatDateWithMonth', function (value, format = 'DD MMM YYYY') {
    if (value) {
        return moment.utc((String(value))).local().locale(lang).format(format);
    }
});

Vue.filter('formatDateWithMonthAndTime', function (value, format = 'DD MMM YYYY HH:mm') {
    if (value) {
        return moment((String(value))).local().locale(lang).format(format);
    }
});

Vue.filter('formatDateHistory', function (value, format = 'ddd, D MMM YYYY HH:mm') {
    if (value) {
        return moment.utc((String(value))).local().locale(lang).format(format);
    }
});